import { PropsWithChildren } from 'react'
import { usePageView } from 'common/hooks/usePageView'

export const PageView = ({ children }: PropsWithChildren<unknown>) => {
  usePageView()
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
